import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";

import { GetServerDateAndTime } from "../queries/queries";
import { ServerDateTimeData, ServerDateTimeVars } from "../queries/types";

const useServerDateandTime = () => {
  const [serverDate, setServerDate] = useState("");
  const [GetDate, { data, loading }] = useLazyQuery<
    ServerDateTimeData,
    ServerDateTimeVars
  >(GetServerDateAndTime, {
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        GetDate();
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetDate]);
  useEffect(() => {
    if (data && !loading) {
      setServerDate(data.GetServerDateAndTime);
    }
  }, [data, loading]);
  return {
    serverDate,
    data,
    loading,
  };
};
export default useServerDateandTime;

